// ABOUTME: Health check hook for maintenance mode detection
// ABOUTME: Provides periodic API health status verification

import { createGStore } from "create-gstore";
import { useCallback, useRef } from "react";

import { publicFetchClient } from "@/shared/api/instance";

export const useMaintenanceHealth = createGStore(() => {
  const isCheckingRef = useRef(false);

  const checkHealth = useCallback(async () => {
    if (isCheckingRef.current) return undefined;
    isCheckingRef.current = true;

    try {
      const { response } = await publicFetchClient.GET("/api/v1/health");
      return response.ok;
    } catch {
      return false;
    } finally {
      isCheckingRef.current = false;
    }
  }, []);

  return { checkHealth };
});
